import { useAuth0 } from "@auth0/auth0-react";
import React, { FC } from "react";
import Button from "@laborhack/custom-button";
import { BusinessSignUpForm } from "./BusinessSignUpForm";
import { Icon } from "semantic-ui-react";

export interface BusinessSignUpProps {}

export const BusinessSignUp: FC<BusinessSignUpProps> = ({}) => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      redirectUri: `${window.location.origin}/auth/register/business`,
    });
  };

  if (!isAuthenticated) {
    return (
      <div>
        <h3 className="text-primary-500 font-bold mb-2">Company Sign Up</h3>
        <Button
          disabled={isAuthenticated}
          loading={isLoading}
          onClick={handleLogin}
        >
          Join LaborHack Marketplace
          <Icon size="large" name="long arrow alternate right" />
        </Button>
        <p className="mt-2">
          *By joining LaborHack, you have agreed to our{" "}
          <a
            href="/terms"
            target="_blank"
            rel="noreferrer"
            className=" !text-accent-500"
          >
            Terms and conditions
          </a>{" "}
          and{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noreferrer"
            className=" !text-accent-500"
          >
            Privacy policy
          </a>
          .
        </p>
      </div>
    );
  }

  return (
    <div>
      <BusinessSignUpForm />
    </div>
  );
};
